import { apiGet, apiPost } from "./client";

export function listApps() {
  return apiGet("/getApps");
}

export function createApp(payload) {
  return apiPost("/createApp", payload);
}

export function updateAppStatus(payload) {
  return apiPost("/updateAppStatus", payload);
}
